import type { Notification } from '../context/AppContext';

/**
 * Badge color for unread count: red only when something needs urgent attention.
 */
export function unreadNotificationBadgeColor(
  notifications: Notification[],
): 'error' | 'warning' | 'success' | 'primary' {
  const unread = notifications.filter((n) => !n.read);
  if (unread.length === 0) {
    return 'primary';
  }
  if (unread.some((n) => n.type === 'error')) {
    return 'error';
  }
  if (unread.some((n) => n.type === 'warning')) {
    return 'warning';
  }
  if (unread.every((n) => n.type === 'success')) {
    return 'success';
  }
  return 'primary';
}
